<template>
  <div id="app" class="app" :class="{ corp: config.tierType === 'CORP' }">
    <router-view></router-view>
    <div v-if="isLandscape" class="landscape-warning" :class="{ corp: config.tierType === 'CORP' }">
      <img src="./assets/rotate.svg" alt="">
      <h1>Please rotate your phone</h1>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app',
  data() {
    return {
      isLandscape: false,
      onResizeSpyBinded: null,
    };
  },
  computed: {
    ...mapGetters([
      'config',
    ]),
  },
  mounted() {
    this.onResizeSpyBinded = this.onResizeSpy.bind(this);
    window.addEventListener('resize', this.onResizeSpyBinded);
    this.onResizeSpy();
  },
  methods: {
    onResizeSpy() {
      this.isLandscape = window.innerWidth > window.innerHeight;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResizeSpyBinded);
  },
};
</script>


<style lang="scss">
@import './styles/_variables.scss';
@import './styles/_reset.scss';

.landscape-warning {
  position: absolute;
  width: 100%;
  height: 100%;
  background: url('./assets/bg-2025.png') ;
  background-size: 100% 100%;
  z-index: 1000;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  justify-content: center;

  img {
    margin: 10px;
  }
  h1 {
    font-size: 20px;
  }
}

.corp {
  background: url('./assets/bg_empty_corp.png');
  background-size: 100% 100%;
}
</style>
